module.exports = __webpack_public_path__ + "static/img/logo.137d7e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 14
// module chunks = 0